import { render, staticRenderFns } from "./SmartListsIndex.vue?vue&type=template&id=72642bc8"
import script from "./SmartListsIndex.vue?vue&type=script&lang=js"
export * from "./SmartListsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports